import { indexedDBStorage } from "../../../common/util/indexedDBStorage";

export const planSelectionPanelLastOpenedTimeStorageKey =
    "PlanSelectionPanelLastOpenedTimeStorageKey";

async function saveOldDate() {
    await indexedDBStorage.setItemAsync(
        planSelectionPanelLastOpenedTimeStorageKey,
        "Wed Jan 01 2025"
    );
}

export async function checkShouldOpenPlanSelectionPanel(): Promise<boolean> {
    const savedData = await indexedDBStorage.getItemAsync(
        planSelectionPanelLastOpenedTimeStorageKey
    );

    if (!savedData) {
        // 一度も開かれていない場合は今回は表示せず、昔の日付を記録。次回訪問時に表示する。
        await saveOldDate();
        return false;
    }

    const savedDate = new Date(savedData);
    const savedTimeNumber = savedDate.getTime();
    if (Number.isNaN(savedTimeNumber)) {
        // データが壊れている場合も今回は表示せず、昔の日付を記録。次回訪問時に表示する。
        await saveOldDate();
        return false;
    }

    const currentTimeNumber = new Date().getTime();

    const diffMs = currentTimeNumber - savedTimeNumber;
    const thirteenDaysMs = 13 * 24 * 60 * 60 * 1000;

    return diffMs >= thirteenDaysMs; // 前回から13日分の時間が経っていれば true
}
